export const NavigationEnum = Object.freeze({
    ROOT: "ROOT",
    CHILD: "CHILD",
});
